(function () {
  var KEY = "lagom_compat_requested",
    MAX = 6,
    LIVE = {
      testing: "testing",
      works: "works",
      works_with_issues: "partial",
      doesnt_work: "not_working",
      blocked: "blocked",
    },
    RANK = { works: 0, partial: 1, untested: 2, not_working: 3, blocked: 4 };
  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/ø/g, "o")
      .replace(/æ/g, "ae")
      .replace(/ß/g, "ss")
      .replace(/ł/g, "l")
      .replace(/đ/g, "d")
      .trim();
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[c];
    });
  }
  function readReq() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function saveReq(app) {
    try {
      var a = readReq();
      a.indexOf(norm(app)) < 0 &&
        (a.push(norm(app)),
        localStorage.setItem(KEY, JSON.stringify(a.slice(-100))));
    } catch (e) {}
  }
  function isReq(app) {
    return readReq().indexOf(norm(app)) > -1;
  }
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    var T = {};
    try {
      T = JSON.parse(root.querySelector("[data-compat-t]").textContent);
    } catch (e) {
      return;
    }
    var dec = document.createElement("textarea");
    Object.keys(T).forEach(function (k) {
      ((dec.innerHTML = T[k]), (T[k] = dec.value));
    });
    var input = root.querySelector("input"),
      live = root.querySelector(".compat__live"),
      sv = /^sv/i.test(root.dataset.locale || ""),
      ep = (root.dataset.endpoint || "").trim();
    /^https?:\/\//.test(ep) || (ep = "");
    var countBase = ep.replace(/\/request\/?$/, ""),
      iconBase = root.dataset.icons || "",
      apps = null,
      loading = null,
      timer = 0,
      counts = {},
      liveStatus = {},
      liveIcon = {};
    function load() {
      if (loading) return loading;
      var fromTheme = function () {
          return fetch(root.dataset.src).then(function (r) {
            return r.json();
          });
        },
        list = countBase
          ? fetch(countBase + "/list")
              .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.json();
              })
              .then(function (d) {
                if (!Array.isArray(d) || !d.length) throw new Error("empty");
                return d;
              })
              .catch(fromTheme)
          : fromTheme();
      return (
        (loading = list
          .then(function (d) {
            ((apps = (Array.isArray(d) ? d : []).map(function (a) {
              var keys = [a.name, T[a.name_key] || ""]
                .concat(String(a.aliases || "").split(","))
                .map(norm)
                .filter(Boolean);
              return { a: a, keys: keys };
            })),
              input.value && run());
          })
          .catch(function () {
            apps = [];
          })),
        loading
      );
    }
    function search(q) {
      var hits = [];
      return (
        apps.forEach(function (x, i) {
          var m = x.keys.some(function (k) {
            return k.indexOf(q) === 0;
          })
            ? 0
            : x.keys.some(function (k) {
                  return k.indexOf(q) > -1;
                })
              ? 1
              : -1;
          m > -1 &&
            hits.push({
              a: x.a,
              s: x.a.status in RANK ? RANK[x.a.status] : 2,
              m: m,
              i: i,
            });
        }),
        hits.sort(function (a, b) {
          return a.s - b.s || a.m - b.m || a.i - b.i;
        }),
        hits.slice(0, MAX).map(function (h) {
          return h.a;
        })
      );
    }
    function known(q) {
      return (
        apps &&
        apps.some(function (x) {
          return x.keys.indexOf(norm(q)) > -1;
        })
      );
    }
    function reqButton(app, isKnown) {
      if (!ep) return "";
      var done = isReq(app);
      return (
        '<button class="compat__req" type="button" data-app="' +
        esc(app) +
        '" data-known="' +
        (isKnown ? "yes" : "no") +
        '"' +
        (done ? " disabled" : "") +
        ">" +
        esc(done ? T.requested : T.request) +
        "</button>"
      );
    }
    function countLine(app) {
      var n = counts[norm(app)];
      return (
        '<p class="compat__count" data-count-for="' +
        esc(norm(app)) +
        '"' +
        (n >= 3 ? "" : " hidden") +
        ">" +
        (n >= 3 ? esc(T.count.replace("{count}", n)) : "") +
        "</p>"
      );
    }
    function item(a) {
      var st = T[a.status] ? a.status : "untested";
      st === "untested" &&
        liveStatus[norm(a.name)] &&
        (st = liveStatus[norm(a.name)]);
      var note = T[a.note_key] || "",
        sub = "";
      (st === "blocked"
        ? (sub = '<p class="compat__note">' + esc(T.blocked_note) + "</p>")
        : st !== "untested" &&
          note &&
          (sub = '<p class="compat__note">' + esc(note) + "</p>"),
        st === "untested" && (sub = countLine(a.name)));
      var icon = a.icon
          ? /^(https?:)?\/\//.test(a.icon)
            ? a.icon
            : iconBase + a.icon
          : liveIcon[norm(a.name)] || "",
        mono =
          '<span class="compat__icon-tile compat__mono" aria-hidden="true"' +
          (icon ? " hidden" : "") +
          ">" +
          esc((a.name.match(/[0-9A-Za-zÀ-ÿ]/) || ["?"])[0].toUpperCase()) +
          "</span>";
      return (
        '<li class="compat__item">' +
        (icon
          ? '<img class="compat__icon-tile" src="' +
            esc(icon) +
            '" width="40" height="40" alt="" loading="lazy" decoding="async">'
          : "") +
        mono +
        '<div><span class="compat__name">' +
        esc(T[a.name_key] || a.name) +
        "</span>" +
        (a.category
          ? '<span class="compat__cat">' + esc(T[a.category_key] || a.category) + "</span>"
          : "") +
        sub +
        '</div><div class="compat__side"><span class="compat__pill compat__pill--' +
        st +
        '">' +
        esc(T[st]) +
        "</span>" +
        (st === "untested" ? reqButton(a.name, !0) : "") +
        "</div></li>"
      );
    }
    function paint(html) {
      ((live.innerHTML = html),
        live.classList.add("is-fading"),
        live.offsetWidth,
        live.classList.remove("is-fading"));
    }
    function fetchCount(app) {
      var k = norm(app);
      !countBase ||
        k in counts ||
        ((counts[k] = 0),
        fetch(countBase + "/count?app=" + encodeURIComponent(app))
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (d) {
            (d && typeof d.count == "number" && setCount(app, d.count),
              d &&
                (d.icon && (liveIcon[norm(app)] = d.icon),
                setLive(app, d.status)));
          })
          .catch(function () {}));
    }
    function setLive(app, status) {
      var st = LIVE[status];
      !st ||
        !T[st] ||
        liveStatus[norm(app)] === st ||
        ((liveStatus[norm(app)] = st), run());
    }
    function setCount(app, n) {
      var k = norm(app);
      ((counts[k] = n),
        !(n < 3) &&
          Array.prototype.forEach.call(
            live.querySelectorAll("[data-count-for]"),
            function (p) {
              p.getAttribute("data-count-for") === k &&
                ((p.textContent = T.count.replace("{count}", n)),
                (p.hidden = !1));
            },
          ));
    }
    function run() {
      var raw = input.value.trim(),
        q = norm(raw);
      if (!q) {
        paint("");
        return;
      }
      if (!apps) {
        load();
        return;
      }
      var res = search(q);
      if (!res.length) {
        if (liveStatus[q]) {
          paint(
            '<ul class="compat__list">' +
              item({ name: raw, status: "untested" }) +
              "</ul>",
          );
          return;
        }
        (fetchCount(raw),
          paint(
            '<div class="compat__empty"><span>' +
              esc(T.no_match).replace("{query}", esc(raw)) +
              "</span>" +
              reqButton(raw, known(raw)) +
              "</div><div>" +
              countLine(raw) +
              "</div>",
          ));
        return;
      }
      (paint('<ul class="compat__list">' + res.map(item).join("") + "</ul>"),
        res.forEach(function (a) {
          a.status === "untested" && fetchCount(a.name);
        }));
    }
    if (
      (live.addEventListener(
        "error",
        function (e) {
          var img = e.target;
          img.tagName === "IMG" &&
            img.nextElementSibling &&
            ((img.nextElementSibling.hidden = !1), img.remove());
        },
        !0,
      ),
      input.addEventListener("focus", load),
      input.addEventListener("input", function () {
        (clearTimeout(timer), (timer = setTimeout(run, 120)));
      }),
      input.addEventListener("keydown", function (e) {
        e.key === "Enter" && (e.preventDefault(), clearTimeout(timer), run());
      }),
      live.addEventListener("click", function (e) {
        var b = e.target.closest(".compat__req");
        if (!(!b || b.disabled || !ep)) {
          var app = b.getAttribute("data-app"),
            label = b.textContent;
          ((b.disabled = !0),
            fetch(ep, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                app: app,
                locale: root.dataset.locale || "",
                known: b.getAttribute("data-known"),
              }),
            })
              .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.json().catch(function () {
                  return {};
                });
              })
              .then(function (d) {
                (saveReq(app),
                  (b.textContent = T.requested),
                  d &&
                    typeof d.count == "number" &&
                    ((counts[norm(app)] = -1), setCount(app, d.count)),
                  d &&
                    (d.icon && (liveIcon[norm(app)] = d.icon),
                    setLive(app, d.status)));
              })
              .catch(function () {
                ((b.disabled = !1), (b.textContent = label));
              }));
        }
      }),
      "IntersectionObserver" in window)
    ) {
      var io = new IntersectionObserver(
        function (en) {
          en[0].isIntersecting && (io.disconnect(), load());
        },
        { rootMargin: "200px" },
      );
      io.observe(root);
    }
  }
  function start() {
    Array.prototype.forEach.call(
      document.querySelectorAll("[data-compat]"),
      init,
    );
  }
  (document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", start)
    : start(),
    document.addEventListener("shopify:section:load", start));
  function motionOff() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }
  function focusSearch(target, wait) {
    var input = target.querySelector(".compat__input");
    input &&
      setTimeout(function () {
        input.focus({ preventScroll: !0 });
      }, wait);
  }
  (document.addEventListener("click", function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="#app-check"]') : null,
      target = document.getElementById("app-check");
    if (!(!a || !target || e.metaKey || e.ctrlKey || e.shiftKey)) {
      var url;
      try {
        url = new URL(a.href, location.href);
      } catch (err) {
        return;
      }
      url.pathname.replace(/\/$/, "") ===
        location.pathname.replace(/\/$/, "") &&
        (e.defaultPrevented ||
          (e.preventDefault(),
          target.scrollIntoView({
            behavior: motionOff() ? "auto" : "smooth",
            block: "start",
          }),
          history.replaceState && history.replaceState(null, "", "#app-check")),
        focusSearch(target, motionOff() ? 60 : 750));
    }
  }),
    location.hash === "#app-check" &&
      window.addEventListener("load", function () {
        var t = document.getElementById("app-check");
        t && t.scrollIntoView({ block: "start" });
      }));
})();

